import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CreateAuctionComponent } from '../createAuction.component';
import { AuctionsService } from '../../../core/service/auctions.service';

@Component({
  selector: 'app-success-add-item',
  templateUrl: './success-add-item.component.html',
  styles: [
  ]
})
export class SuccessAddItemComponent {
  constructor(private dialog: MatDialog,
    private service :AuctionsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SuccessAddItemComponent>) {

  }
  ngOnInit(): void {

  }


  onCreateAuction() {
    this.dialogRef.close(true);
  }

  refreshList(){
    this.service.LoadListNow.next(true)
  }

}
